import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSidebar } from "./context/sidebarContext";
import Sidebar from "./Sidebar";
import styles from "./styles/Dashboard.module.css";
import MainCourseContentLearning from "./components/learning/pages/mainCourseContentLearning";
import { useParams, useNavigate } from "react-router-dom";
import { baseAxios } from "./apis";
import Layout from "./components/ui/Layout";

// 1. Create a custom hook for fetching a single lesson's details.
const useLessonDetailQuery = (lesson_id) => {
  return useQuery({
    // The query key is unique for each lesson.
    queryKey: ["lessonDetail", lesson_id],
    queryFn: () =>
      baseAxios
        .get(`/api/courses/lessons/${lesson_id}`)
        .then((res) => res.data),
    // The query will only run if lesson_id exists.
    enabled: !!lesson_id,
  });
};

export const LearnContent = () => {
  const { lesson_id } = useParams();
  const navigate = useNavigate();

  // 2. Call the new hook to get data, loading, and error states.
  const {
    data: lessonDetail,
    isLoading: loading,
    isError,
  } = useLessonDetailQuery(lesson_id);

  // All manual useState and data-fetching useEffect hooks are now removed.

  // This effect for redirecting if no ID is present remains.
  useEffect(() => {
    if (!lesson_id) {
      navigate("/learn", { replace: true });
    }
  }, [lesson_id, navigate]);

  // 3. Use a separate useEffect to handle the navigation side effect on error.
  useEffect(() => {
    if (isError) {
      console.error("Lesson not found or error fetching lesson details.");
      navigate("/learn", { replace: true });
    }
  }, [isError, navigate]);

  // Prevent rendering if there's no ID.
  if (!lesson_id) return null;

  // The rest of your component's JSX is unchanged.
  return (
    <Layout>
      <MainCourseContentLearning
        lessonDetail={lessonDetail}
        loading={loading}
      />
    </Layout>
  );
};
